import React, { createContext, useReducer } from 'react'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case 'connector_view': {
      return { ...data, connector_view: payload.data }
    }
    case 'displayGroups': {
      return { ...data, displayGroups: payload.data }
    }
    case 'displaySource': {
      return { ...data, displaySource: payload.data }
    }
    case 'displayMappings': {
      return { ...data, displayMappings: payload.data }
    }
    case 'displayPng': {
      return { ...data, displayPng: payload.data }
    }

    case 'displayConnector': {
      return { ...data, displayConnector: payload.data }
    }
    case 'selected_reference': {
      return { ...data, selected_reference: payload.data }
    }
    case 'select_mapping': {
      return {
        ...data,
        connector: payload.data.connector,
        svg_group_reference: payload.data.svg_group_reference,
        selected_reference: payload.data.selected_reference,
      }
    }
    case 'update_mapping_and_reference': {
      return {
        ...data,
        connector: payload.data.connector,
        svg_group_reference: payload.data.svg_group_reference,
        selected_reference: payload.data.selected_reference,
        connector_view: payload.data.connector_view,
        mappedReferences: payload.data.mappedReferences,
      }
    }
    case 'mappedReferences': {
      return {
        ...data,
        mappedReferences: payload.data,
      }
    }
    case 'selected_svg_object': {
      return {
        ...data,
        selected_svg_object: payload.data,
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  connector_view: {},
  displayGroups: false,
  displaySource: false,
  displayMappings: true,
  displayConnector: false,
  displayPng: true,
  connector: {},
  svg_group_reference: null,
  selected_reference: null,
  selected_svg_object: null,
  mappedReferences: {},
}

const ConnectorViewMappingStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <ConnectorViewMappingContext.Provider value={[state, dispatch]}>
      {children}
    </ConnectorViewMappingContext.Provider>
  )
}

export const ConnectorViewMappingContext = createContext(initialState)
export default ConnectorViewMappingStore
